import "./index.css";

import { createApiClient } from "@pokifolio/api-client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/app";

const api = createApiClient({ baseUrl: import.meta.env.VITE_API_URL ?? "http://localhost:3000" });

const container = document.getElementById("root");
if (container === null) throw new Error("Missing #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <App api={api} />
  </StrictMode>,
);
